<template>
    <div class="contract-data-view">
        <div class="contract-data-view__item">
            <span>{{ translate('contract_number') }}</span>
            <span>{{ report.contract_number }}</span>
        </div>
        <div class="contract-data-view__item">
            <span>{{ translate('contract_volume') }}</span>
            <span>{{ formatters.formatNumber(report.volume) }}</span>
        </div>
        <div class="contract-data-view__item">
            <span>{{ translate('safra') }}</span>
            <span>{{ report.safra }}</span>
        </div>
        <div class="contract-data-view__item">
            <span>{{ translate('cultivation') }}</span>
            <span>{{ report.cultivation }}</span>
        </div>
        <div class="contract-data-view__item">
            <span>{{ translate('client') }}</span>
            <span v-if="isContractOwner">{{ report.company_name }}</span>
            <span v-else>{{ report.client_name }}</span>
        </div>
        <div class="contract-data-view__item">
            <span>{{ translate('contract_date') }}</span>
            <span>{{ report.contract_date }}</span>
        </div>
        <div class="contract-data-view__item">
            <span>{{ translate('delivery_location') }}</span>
            <span>{{ report.delivery_location }}</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Formatters from '@/utils/formatters';

export default {
    name: 'ContractDataPy',
    data() {
        return {
            formatters: Formatters
        };
    },
    computed: {
        ...mapGetters('traceabilityContractModule', {
            report: 'getReport',
            isContractOwner: 'isContractOwner'
        })
    },
    methods: {
        translate(key) {
            const base = 'contrato_rastreabilidade.messages.view';
            return this.$t(`${base}.${key}`);
        }
    }
};
</script>
<style scoped lang="scss">
.contract-data-view {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }

    .contract-data-view__item {
        display: flex;
        flex-direction: column;
        font-size: 14px;

        span:first-child {
            font-weight: 400;
        }
        span:last-child {
            font-weight: 500;
        }
    }
}
</style>
